/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceRoleBulkSyncRequest
 */
export interface ServiceRoleBulkSyncRequest {
    /**
     * Partner uuids that should remain mapped to the service agreement. An empty list means all currently mapped service roles are submitted for deactivation.
     * @type {Array<string>}
     * @memberof ServiceRoleBulkSyncRequest
     */
    partnerUids: Array<string>;
    /**
     * Contact note uuids to link to the service agreement, on top of the ones it already has. Linking is additive, so notes that are already linked are left alone and no note is ever unlinked here.
     * @type {Array<string>}
     * @memberof ServiceRoleBulkSyncRequest
     */
    contactNoteUids?: Array<string>;
}

/**
 * Check if a given object implements the ServiceRoleBulkSyncRequest interface.
 */
export function instanceOfServiceRoleBulkSyncRequest(value: object): value is ServiceRoleBulkSyncRequest {
    if (!('partnerUids' in value) || value['partnerUids'] === undefined) return false;
    return true;
}

export function ServiceRoleBulkSyncRequestFromJSON(json: any): ServiceRoleBulkSyncRequest {
    return ServiceRoleBulkSyncRequestFromJSONTyped(json, false);
}

export function ServiceRoleBulkSyncRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceRoleBulkSyncRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUids': json['partnerUids'],
        'contactNoteUids': json['contactNoteUids'] == null ? undefined : json['contactNoteUids'],
    };
}

export function ServiceRoleBulkSyncRequestToJSON(json: any): ServiceRoleBulkSyncRequest {
    return ServiceRoleBulkSyncRequestToJSONTyped(json, false);
}

export function ServiceRoleBulkSyncRequestToJSONTyped(value?: ServiceRoleBulkSyncRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUids': value['partnerUids'],
        'contactNoteUids': value['contactNoteUids'],
    };
}

